import { useLoaderData } from 'react-router';

import type { loader } from '@modules/professional/page/loaders/overview-page-loader.server';
import { EditorialHeader, TeamGrid } from '~/ui-rocco/pages/detail-shared';
import { formatSectionNumber } from '../utils/section-numbering';

interface ProfessionalTeamSectionProps {
    sectionNumber?: number;
}

/**
 * §6 — Team. "Who we are" header + the shared {@link TeamGrid} of the
 * professional's public team members (portrait, name, role): two columns on
 * mobile, four on desktop. Self-hides when there are none.
 */
export const ProfessionalTeamSection = ({
    sectionNumber,
}: ProfessionalTeamSectionProps = {}) => {
    const { teamMembers, projectCategories } = useLoaderData<typeof loader>();

    if (!teamMembers || teamMembers.length === 0) return null;

    const categoryPills = projectCategories.map(({ title, link }) => ({
        label: title,
        to: link,
    }));

    return (
        <section className="bg-white">
            <EditorialHeader
                theme="light"
                eyebrow={`(${formatSectionNumber(sectionNumber ?? 2)} — Team)`}
                heading="Who we are"
                description="Meet the people behind the work — the team who bring each project to life."
                categories={
                    categoryPills.length > 0 ? categoryPills : undefined
                }
            />
            <div className="mx-auto w-full max-w-[120rem] max-md:px-6 max-md:pt-8 md:px-[3rem] md:pt-[3rem]">
                <TeamGrid members={teamMembers} />
            </div>
        </section>
    );
};
